import JsonManager from './JsonManager';

class AboutSkillManager {
  constructor(skill) {
    this.skill = skill;
  }

  getTitle() {
    return this.skill.title;
  }

  getList() {
    return this.skill.list;
  }
}

class AboutManager {
  constructor() {
    this.about = JsonManager.getAbout();
  }

  getImage() {
    return this.about.image;
  }

  getTitle() {
    return this.about.title;
  }

  getMessage() {
    return this.about.message;
  }

  getSkillsTitle() {
    return this.about.skills_title;
  }

  getSkills() {
    const skills = [];
    const aboutSkills = this.about.skills;
    for (let i = 0; i < aboutSkills.length; i += 1) {
      const skill = new AboutSkillManager(aboutSkills[i]);
      skills.push(skill);
    }

    return skills;
  }
}

export default AboutManager;



// WEBPACK FOOTER //
// ./src/managers/AboutManager.js